module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "id": "iint"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("INTRODUCTION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "iequ"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/equipment#equ"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("EQUIPMENT")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "iing"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ingredients#ing"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("INGREDIENTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "id": "ich1"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch1"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("CHAPTER ONE: CAKES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich1.1"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch1.1"
    }
  }, [_vm._v("Grandmom Lindner’s Favorite Gingerbread Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich1.2"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch1.2"
    }
  }, [_vm._v("Gingerbread Pound Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich1.3"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch1.3"
    }
  }, [_vm._v("Pumpkin-Gingerbread Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich1.4"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch1.4"
    }
  }, [_vm._v("Apple Butter-Gingerbread Cake with Brown Sugar Frosting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich1.5"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch1.5"
    }
  }, [_vm._v("Spiced Pear Upside-Down Gingerbread Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich1.6"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch1.6"
    }
  }, [_vm._v("Gingerbread Rum Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich1.7"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch1.7"
    }
  }, [_vm._v("Ginger Syrup-Soaked Gingerbread Cakes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich1.8"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch1.8"
    }
  }, [_vm._v("Marbled Gingerbread-Almond Loaf Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich1.9"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch1.9"
    }
  }, [_vm._v("Robert’s Celebration Gingerbread Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich1.10"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch1.10"
    }
  }, [_vm._v("Carol Lee’s Jeweled Gingerbread Fruitcake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich1.11"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch1.11"
    }
  }, [_vm._v("Rich Chocolate Gingerbread")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich1.12"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch1.12"
    }
  }, [_vm._v("Eliza Leslie’s Lafayette Gingerbread")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "id": "ich2"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("CHAPTER TWO: COOKIES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich2.1"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch2.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old-Time Gingersnaps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich2.2"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch2.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five-Spice Gingersnaps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich2.3"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch2.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pressed Spicy Gingerbread Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich2.4"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch2.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moravian Ginger Thins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich2.5"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch2.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cutout Gingerbread Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich2.6"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch2.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Golden Gingerbread Cutout Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich2.7"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch2.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shimmering Gingerbread Maple Leaves")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich2.8"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch2.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate-Ginger Crinkle Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich2.9"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch2.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Giant Chewy Ginger Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich2.10"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch2.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Logan’s Favorite Soft Molasses Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich2.11"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch2.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingerbread Shortbread Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich2.12"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch2.12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Twice-Gingered Shortbread")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich2.13"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch2.13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingerbread Madeleines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich2.14"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch2.14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Braune Lebkuchen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich2.15"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch2.15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pfeffernüsse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich2.16"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch2.16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soft Gingerbread Biscotti")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich2.17"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch2.17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alexis’s “Oh, Wow” Gingerbread Blondies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich2.18"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch2.18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kate’s Gingerbread Brownies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "id": "ich3"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("CHAPTER THREE: DESSERTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich3.1"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch3.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Burgundian Bread & Butter Pudding with Pain d’Épices & Quince")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich3.2"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch3.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingerbread Bread Pudding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich3.3"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch3.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sticky Toffee Gingerbread Pudding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich3.4"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch3.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingerbread-Maple Moon Pies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich3.5"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch3.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingerbread-Pumpkin Ice Cream Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich3.6"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch3.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingerbread-Blackberry Trifle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich3.7"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch3.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chris’s Pumpkin-Gingerbread Torte")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich3.8"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch3.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingerbread Bûche de Noël with Chocolate & Chestnut Buttercreams")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "id": "ich4"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("CHAPTER FOUR: ICE CREAMS & CONFECTIONS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich4.1"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch4.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingerbread Ice Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich4.2"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch4.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caramel-Ginger Cookie-Chocolate Chunk Ice Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich4.3"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch4.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pain d’Épices Ice Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich4.4"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch4.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pumpkin-Gingersnap Ice Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich4.5"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch4.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingerbread-Hazelnut Rum Balls")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich4.6"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch4.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingerbread Butter Drops with Lemon Glaze")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich4.7"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch4.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Panforte Margherita")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich4.8"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch4.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Burgundian Spiced Caramels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich4.9"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch4.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spiced Christmas Toffee")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "id": "ich5"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("CHAPTER FIVE: GINGERBREAD FOR BREAKFAST")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich5.1"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch5.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingerbread Pancakes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich5.2"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch5.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingerbread-Pumpkin Waffles with Vanilla Sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich5.3"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch5.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingerbread Doughnuts with Cinnamon Sugar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich5.4"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch5.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pain d’Épices")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich5.5"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch5.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pain d’Épices French Toast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich5.6"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch5.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingerbread-Cranberry Scones")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "id": "ich6"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("CHAPTER SIX: GINGERBREAD HOUSES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich6.1"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch6.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gingerbread House Dough")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich6.2"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch6.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich6.3"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch6.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Betsy Ross House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch"
  }, [_c('a', {
    attrs: {
      "id": "ich7"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("CHAPTER SEVEN: BASICS & ACCOMPANIMENTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich7.1"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch7.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whipped Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich7.2"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch7.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crème Anglaise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich7.3"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch7.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vanilla Ice Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich7.4"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch7.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dede’s Italian Buttercream")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich7.5"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch7.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Royal Icing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich7.6"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch7.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dark Chocolate Glaze")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-ch1"
  }, [_c('a', {
    attrs: {
      "id": "ich7.7"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch7.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Candied Orange Peel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-em1"
  }, [_c('a', {
    attrs: {
      "id": "iindex"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("INDEX")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-em"
  }, [_c('a', {
    attrs: {
      "id": "iack"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("ACKNOWLEDGMENTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-em"
  }, [_c('a', {
    attrs: {
      "id": "itab"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/table#tab",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("TABLE OF EQUIVALENTS")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0